import { render, staticRenderFns } from "./Furnitures.vue?vue&type=template&id=42dca129&scoped=true&"
import script from "./Furnitures.vue?vue&type=script&lang=js&"
export * from "./Furnitures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dca129",
  null
  
)

export default component.exports